<template>
  <div>
    <div v-show="['/work','/complianceBusiness/EPRList','/complianceBusiness/EPRDeclareList'].includes(curUrl)" class="amz-btn" @click="openAmz"><img src="@comp/images/common/amz_btn.png" /></div>
    <div class="amz-img" v-if="amzVisible">
      <div>
        <img width="540px" src="@comp/images/common/amz_img02.png" />
        <span @click="closeAmz" class="amz-close-btn"></span>
        <!-- <img @click="closeAmz" class="amz-close" alt="关闭" width="36px" src="@comp/images/common/amz_close.png" /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      amzVisible: false,
      curUrl: '',
    };
  },
  watch: {
    // 仅同步当前路由，用于控制右下角入口的显示范围；公告不再自动弹出。
    '$route.path': {
      handler(newVal) {
        this.curUrl = newVal;
      },
      immediate: true,
    }
  },
  methods: {
    openAmz() {
      this.amzVisible = true;
    },
    closeAmz() {
      this.amzVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.amz-img {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    width: 540px;
    height: 495px;
    text-align: center;
    position: relative;
    margin-top: -100px;
    .amz-close {
      cursor: pointer;
      margin-top: 10px;
    }
  }
}

.amz-btn {
  position: fixed;
  cursor: pointer;
  bottom: 39px;
  right: 0;
  height: 50px;
  z-index: 9998;
  img {
    position: absolute;
    top: 0;
    right: 0;
    width: 236px;
  }
}
.amz-close-btn{
  display: block;
  width: 210px;
  height: 60px;
  position: absolute;
  left: 50%;
  bottom: -51px;
  margin-left: -105px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/module/components/amzPop.vue